// extracted by mini-css-extract-plugin
export default {"banner":"DiscoverRegionBanner_banner__PrYZO","header":"DiscoverRegionBanner_header__2+-4U"};